import BottomButtonContainer from "@/components/shared/ui/BottomButtonContainer/BottomButtonContainer";
import MovePrevStepButton from "@/components/shared/ui/MovePrevStepButton/MovePrevStepButton";
import TopFixInfo from "@/components/shared/ui/TopFixInfo/TopFixInfo";
import UpdateStatusButtons from "@/components/shared/ui/UpdateStatusButtons/UpdateStatusButtons";
import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";
import { usePressIdFromURL } from "@utils/getStateFromURL";

import ArticleDetailBody from "./components/ArticleDetailBody/ArticleDetailBody";
import ArticleDetailFabContentBox from "./components/ArticleDetailFabContentBox/ArticleDetailFabContentBox";
import ArticleHeader from "./components/ArticleHeader/ArticleHeader";
import EditArticleUnsuitableButton from "./components/EditArticleUnsuitableButton/EditArticleUnsuitableButton";
import PublishButton from "./components/PublishButton/PublishButton";
import * as S from "./EditArticle.style";
import EditArticleProvider from "../EditArticleProvider/EditArticleProvider";

const EditArticle = () => {
  const draftArticleId = usePressIdFromURL();
  const { data: articleInfo } = useArticleInfoQuery(Number(draftArticleId));

  const isDisabledEdit = articleInfo?.draftArticleStatusHighest === "S930";

  return (
    <EditArticleProvider>
      <S.EditArticleWrapper>
        <S.EditArticleScrollSection>
          <S.TopFixInfoWrapper>
            <TopFixInfo />
          </S.TopFixInfoWrapper>

          <S.DisabledWrapper isDisabledEdit={isDisabledEdit}>
            <ArticleHeader />
            <S.ContentsWrapper>
              <ArticleDetailBody />
            </S.ContentsWrapper>
          </S.DisabledWrapper>
        </S.EditArticleScrollSection>

        <S.CenterContainer>
          <BottomButtonContainer>
            <S.ButtonLeftButtonWrapper>
              <MovePrevStepButton label="Insert Image" page="insertImage" />
              <EditArticleUnsuitableButton />
              <UpdateStatusButtons />
            </S.ButtonLeftButtonWrapper>
            <S.RightButtonWrapper>
              <ArticleDetailFabContentBox />
              <PublishButton />
            </S.RightButtonWrapper>
          </BottomButtonContainer>
        </S.CenterContainer>
      </S.EditArticleWrapper>
    </EditArticleProvider>
  );
};

export default EditArticle;
